import React from 'react';
import { Grid } from '@mui/material';
import { useListPropertyContext } from '../../../../../contexts/ListPropertyContext';
import ReusableTextField from '../../../../../components/ReusableTextField/ReusableTextField';

const AddressSection = () => {
  const { formData, updateFormData } = useListPropertyContext();

  const handleCityChange = (e) => {
    updateFormData('city', e.target.value);
  };

  const handleStreetChange = (e) => {
    updateFormData('street', e.target.value);
  };

  const handleBuildingChange = (e) => {
    updateFormData('building', e.target.value);
  };

  const handleZipCodeChange = (e) => {
    updateFormData('zipCode', e.target.value);
  };

  return (
    <Grid container spacing={2}>
      {/* Row 1 */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <ReusableTextField
          label="City"
          value={formData.city}
          onChange={handleCityChange}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <ReusableTextField
          label="Street"
          value={formData.street}
          onChange={handleStreetChange}
        />
      </Grid>
      {/* Row 2 */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <ReusableTextField
          label="Building"
          value={formData.building}
          onChange={handleBuildingChange}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <ReusableTextField
          label="Zip Code"
          value={formData.zipCode}
          onChange={handleZipCodeChange}
        />
      </Grid>
    </Grid>
  );
};

export default AddressSection;

